import { ReportUserChatSessionService } from "@/services";
import Toast from "@/helpers/toast.helper";

const state = () => ({
  loading: false,
  loadingCount: false,
  data: [],
  pagination: {
    current: 1,
    pageSize: 10,
    total: 0,
  },
  total_sessions: 0,
  avg_duration_with_bot: 0,
  avg_bot_message_count: 0,
  avg_customer_message_count: 0,
  filterText: "",
});

const mutations = {
  SET_LOADING(state, isLoading) {
    state.loading = isLoading;
  },
  SET_LOADING_COUNT(state, isLoading) {
    state.loadingCount = isLoading;
  },
  SET_DATA(state, data) {
    state.data = data;
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = { ...state.pagination, ...pagination };
  },
  SET_FILTER_TEXT(state, text) {
    state.filterText = text;
  },
  SET_COUNT_DATA(state, data) {
    state.total_sessions = data.total_sessions || 0;
    state.avg_duration_with_bot = data.avg_duration_with_bot || 0;
    state.avg_bot_message_count = data.avg_bot_message_count || 0;
    state.avg_customer_message_count = data.avg_customer_message_count || 0;
  },
};

const actions = {
  async fetchDatatableUserChatSession({ commit, state }, { filters, sort } = {}) {
    commit("SET_LOADING", true);
    try {
      const response = await ReportUserChatSessionService.datatable({
        page: state.pagination.current,
        per_page: state.pagination.pageSize,
        search: filters.search,
        dateStart: filters.dateStart,
        dateEnd: filters.dateEnd,
        sort: sort,
      });
      commit("SET_DATA", response.data.data);
      commit("SET_PAGINATION", { total: response.data.total });
    } catch (error) {
      console.error("Error fetching user chat session data:", error);
      Toast.error("Failed to fetch user chat session data.");
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async fetchCountReport({ commit }, { filters } = {}) {
    commit("SET_LOADING_COUNT", true);
    try {
      const response = await ReportUserChatSessionService.countReport({
        search: filters.search,
        dateStart: filters.dateStart,
        dateEnd: filters.dateEnd,
      });
      commit("SET_COUNT_DATA", response.data.data);
    } catch (error) {
      console.error("Error fetching user chat session count:", error);
      Toast.error("Failed to fetch user chat session count.");
    } finally {
      commit("SET_LOADING_COUNT", false);
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};